import { render, staticRenderFns } from "./ReportDefect.vue?vue&type=template&id=88f70f98&scoped=true&"
import script from "./ReportDefect.vue?vue&type=script&lang=js&"
export * from "./ReportDefect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f70f98",
  null
  
)

export default component.exports